module.exports = __webpack_public_path__ + "static/media/youtube.6ce079da.svg";